import { render } from "./FeederTotalCal.vue?vue&type=template&id=7ab4c374"
import script from "./FeederTotalCal.vue?vue&type=script&lang=js"
export * from "./FeederTotalCal.vue?vue&type=script&lang=js"
script.render = render

export default script